import { type UseQueryResult, useQuery } from 'react-query';
import {
  BrokerAttestationAuditLogService,
  type PagedResultDto_BrokerAttestationAuditLogListItemDto,
} from '@wealthlane/api-services/wealthlane-customer-service';
import { type TableParamsType } from '../../types/common';

const useGetBrokerAttestationAuditLogs = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType
): UseQueryResult<PagedResultDto_BrokerAttestationAuditLogListItemDto | undefined, unknown> => {
  const { filter, sorting, skipCount, maxResultCount, fromDate, toDate } = tableInfo;

  return useQuery(
    ['getBrokerAttestationAuditLogs', filter, sorting, skipCount, maxResultCount, fromDate, toDate],
    async () => {
      return await handleRequest(
        BrokerAttestationAuditLogService.getApiCustomerApiBrokerAttestationsAuditLogs(
          fromDate,
          toDate,
          filter,
          sorting,
          skipCount,
          maxResultCount
        )
      );
    }
  );
};

export default useGetBrokerAttestationAuditLogs;
